// Translations
import {
  BIRTHDATE,
  FULL_NAME,
  NACIONALITY,
} from '../translations/upload-id-different-data.configuration.translations';

const UPLOAD_ID_DIFFERENT_DATA_CUSTOMER_DATA_CONFIGURATION = [
  {
    id: 'fullName',
    label: FULL_NAME,
    testId: 'upload-id-different-data-customer-fullname',
  },

  {
    id: 'birthDate',
    label: BIRTHDATE,
    testId: 'upload-id-different-data-customer-birthdate',
  },
  {
    id: 'nationality',
    label: NACIONALITY,
    testId: 'upload-id-different-data-customer-nationality',
  },
];

export { UPLOAD_ID_DIFFERENT_DATA_CUSTOMER_DATA_CONFIGURATION };
